import React from 'react';
import { Link } from 'react-router-dom';
import './style/Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer__container">
        <p className="footer__text">
          &copy; 2026 Studio Vinzaglio 24 - Torino.
        </p>
        <ul className="footer__list">
          <li className="footer__item">
            <Link to="/" className="footer__link">
              Home
            </Link>
          </li>
          <li className="footer__item">
            <Link to="/cosa-facciamo" className="footer__link">
              Cosa facciamo
            </Link>
          </li>
          <li className="footer__item">
            <Link to="/chi-siamo" className="footer__link">
              Chi siamo
            </Link>
          </li>
          <li className="footer__item">
            <Link to="/contatti" className="footer__link">
              Contatti
            </Link>
          </li>
        </ul>
      </div>
    </footer>
  );
};

export default Footer;
